import * as Sentry from '@sentry/react';
import type { Scope } from '@sentry/react';
import { ReactNode } from 'react';

import { ErrorBoundary } from './ErrorBoundary';
import { isChunkLoadError } from './isChunkLoadError';

interface SentryErrorBoundaryProps {
  children: ReactNode;
}

export const SentryErrorBoundary = ({ children }: SentryErrorBoundaryProps) => {
  // React Compiler must not auto-memoize this fallback: Sentry invokes it
  // imperatively from a class render() (no React dispatcher), so any
  // compiler-injected useMemo throws "Invalid hook call" (React #321).
  'use no memo';

  const handleBeforeCapture = (scope: Scope, error: Error | null) => {
    // Skip error if it matches a specific condition
    if (isChunkLoadError(error)) {
      return null;
    }

    return scope;
  };

  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        return <ErrorBoundary error={error} />;
      }}
      beforeCapture={handleBeforeCapture}
      onError={(error: Error, componentStack: string) => {
        // eslint-disable-next-line
        console.log(componentStack, error);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
